import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent } from 'devextreme-angular';

import { AppService } from '@api';
import { SistemaService } from '@servicios/Sistema.Service';

import { AlertaEnum } from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import { MensajeService } from '@mensaje/Mensaje.Service';
import { RespuestaEstatusEnum } from '@enumeraciones/Enumeraciones.enum';

import { Colaborador } from '@modelo/catalogo/Colaborador.model';

@Component(
  {
    selector: 'colaboradorevaluacionmodal',
    templateUrl: './colaboradorevaluacion.template.html',
    styleUrls: ['./colaboradorevaluacion.component.scss']
  })

export class ColaboradorEvaluacionModalComponent {
  @Input() seleccionMultiple: boolean = false;
  @Output() respuesta = new EventEmitter();
  dataTable: Array<any>;

  listcolaboradorduplicado: any[];
  personaevaluar: string = "";
  departamento: string = "";
  puesto: string = "";
  nivel: string = "";
  grado: string = "";
  grupo: string = "";
  fechaaplicacion: string = "";
  colaboradorconpuesto: number = 0;
  agruparcolaborador: number = 0;
  cicloid: number = 0;
  gradoid: number = 0;
  solomaestros: any[] = [];
  nivelid: number = 0;
  vermateria: boolean = false;

  public entidad: Colaborador;

  public abierto!: boolean;
  public animacion!: string;

  @ViewChild('grid') private grid!: DxDataGridComponent;

  constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService) {
    this.entidad = new Colaborador();
    this.dataTable = [];
    this.listcolaboradorduplicado = [];

  }

  Modal() {
    this.animacion = this.sistemaService.animacionAbirModal;
    this.abierto = true;
  }

  CerrarModal() {
    this.LimpiarFiltros();
    this.animacion = this.sistemaService.animacionCerrarModal;

    setTimeout(() => {
      this.abierto = false;
    }, 310);
  }


  LimpiarFiltros() {
    this.entidad = new Colaborador();
    this.dataTable = [];
  }

  Buscar() {
    let data = new Colaborador(this.entidad);
    if(this.solomaestros.length > 0){
      this.appService.Post("configuracionrh/colaborador/asignacionprofesor", {"data":data, "lista":this.listcolaboradorduplicado, "maestros": this.solomaestros,"solopuestos":this.colaboradorconpuesto, "nivelid":this.nivelid, "cicloid":this.cicloid, "gradoid":this.gradoid}).then(res => {
        if (res.status == RespuestaEstatusEnum.Success) {
          this.dataTable = res.data;
          if(this.dataTable[0].materia){
            this.vermateria = true;
          }else{
            this.vermateria = false;
          }
        }
      })
    }else{
      this.appService.Post("configuracionrh/colaborador/asignacion", {"data":data, "lista":this.listcolaboradorduplicado, "solopuestos":this.colaboradorconpuesto}).then(res => {
        if (res.status == RespuestaEstatusEnum.Success) {
          this.dataTable = res.data;
          this.vermateria = false;
        }
      })
    }
  }

  Guardar() {
    let checked = this.grid.instance.getSelectedRowsData();
    if (this.seleccionMultiple) {
      if (!checked.length) {
        return this.mensajeService.Alerta(AlertaEnum.Warning, "Seleccione uno o más registros");
      }
      if(this.agruparcolaborador == 1){
        let listaunica: any[] = [];
        const lista = checked;
        lista.forEach(data=>{
         let objeto =  listaunica.findIndex(x=>x.colaboradorid == data.colaboradorid);

         if(objeto == -1){
          listaunica.push(data);
         }
        })
        this.respuesta.next(listaunica);
      }else{
        this.respuesta.next(checked);
      }

    } else {
      if (checked.length != 1) {
        return this.mensajeService.Alerta(AlertaEnum.Warning, "Seleccione solo un registro");
      }
      this.respuesta.next(checked[0])
    }



  }

}
